import React from "react";
import "../../styles/headerHome.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 University Sharing</p>
      <div className="links">
        <span>Chính sách</span>
        <span>Về chúng tôi</span>
        <span>Quyền riêng tư</span>
      </div>
    </footer>
  );
};

export default Footer;
